module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white@2x-eb9bb8597561627edea11612430bc45a.png";